import { render, staticRenderFns } from "./PerformanceSkeleton.vue?vue&type=template&id=52275495&scoped=true"
import script from "./PerformanceSkeleton.vue?vue&type=script&lang=js"
export * from "./PerformanceSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PerformanceSkeleton.vue?vue&type=style&index=0&id=52275495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52275495",
  null
  
)

export default component.exports